import { Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ButtonStyled } from "./ButtonStyled";

interface Props {
  label: string;
  onClick?: () => void;
  bottom?: number;
  left?: number | string;
  disabled?: boolean;
  id?: string;
}

const BottomButton = ({ label, onClick, bottom, left, disabled, id }: Props) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      className="base-adron-paper paper-light"
      sx={{
        backgroundColor: theme.palette.background.paper,
        boxShadow: "0px -4px 6px -1px rgba(0, 0, 0, 0.10",
      }}
    >
      <ButtonStyled
        disabled={disabled}
        onClick={onClick}
        style={{
          padding: "8px 16px",
          color: "#fff",
          fontWeight: 600,
          height: "40px",
        }}
        fullWidth={true}
        color={"primary"}
        variant="contained"
      >
        {label}
      </ButtonStyled>
    </Paper>
  );
};

export default BottomButton;
